/* eslint-disable no-throw-literal */
import normalizeById from 'app/utils/NormalizeById';
import ApiService from 'app/services/ApiService';

export const CATEGORYCOURSEAVAILABLE_ADD = 'CATEGORYCOURSEAVAILABLE_ADD';
export const CATEGORYCOURSEAVAILABLE_BEGIN = 'CATEGORYCOURSEAVAILABLE_BEGIN';
export const CATEGORYCOURSEAVAILABLE_FAILURE = 'CATEGORYCOURSEAVAILABLE_FAILURE';
export const CATEGORYCOURSEAVAILABLE_CLEAR = 'CATEGORYCOURSEAVAILABLE_CLEAR';

export function fetchCategoryCourseAvailable(data) {
    return async dispatch => {
        dispatch(categoryCourseAvailableBegin());
        await ApiService.getCategoriesCourseAvailable(data)
            .then(
                result => {
                    let normalized = normalizeById(result.Data, 'idCategory');
                    dispatch(categoryCourseAvailableAdd(normalized));
                    return normalized;
                },
                error => {
                    dispatch(categoryCourseAvailableError());
                    throw ({ error: error, message: 'An error ocurred' });
                }
            )
    };
}


export const categoryCourseAvailableBegin = () => ({
    type: CATEGORYCOURSEAVAILABLE_BEGIN,
});

export const categoryCourseAvailableAdd = data => ({
    type: CATEGORYCOURSEAVAILABLE_ADD,
    payload: { data }
})

export const categoryCourseAvailableError = () => ({
    type: CATEGORYCOURSEAVAILABLE_FAILURE,
})

export const categoryCourseAvailableClear = () => ({
    type: CATEGORYCOURSEAVAILABLE_CLEAR,
})